import { render, staticRenderFns } from "./LoanContract.vue?vue&type=template&id=37d69d9c"
import script from "./LoanContract.vue?vue&type=script&lang=js"
export * from "./LoanContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports